import {differenceInCalendarDays, isSameDay, parse} from 'date-fns';

import {DateFormatEnum} from 'presentation/constants';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {formatDateString, formatText, getOnlyFirstWord} from 'presentation/utils';
import {BookingTypeEnum} from '../../booking/constants';
import {UseAppointmentNotificationsProps} from './types';
import {isAppointmentPastDue} from '../../home/utils/isAppointmentPastDue';

export function useAppointmentNotifications({appointment}: UseAppointmentNotificationsProps) {
	const accountData = useAccountDataStore(store => store.accountData);

	const nearestAppointment = appointment;
	const nearestAppointmentType = nearestAppointment.bookingType;
	const isExam = nearestAppointmentType === BookingTypeEnum.EXAM;
	const isSurgery = nearestAppointmentType === BookingTypeEnum.SURGERY;

	const parsedAppointmentDate = parse(appointment.date, DateFormatEnum.DATE_FORMAT_1, new Date());

	const isToday = isSameDay(parsedAppointmentDate, new Date());
	const daysFromAppointmentDate = differenceInCalendarDays(parsedAppointmentDate, new Date());
	const isPastDue = isAppointmentPastDue(appointment.date);

	const formattedDate = formatDateString(appointment.date, DateFormatEnum.DATE_FORMAT_1, 'H:mm');

	const formattedBeneficiary = getOnlyFirstWord(
		formatText(accountData.beneficiary.nmSocialUsuarioC || accountData.beneficiary.nmUsuarioC),
	);

	return {
		formattedDate,
		formattedBeneficiary,
		isExam,
		nearestAppointmentType,
		daysFromAppointmentDate,
		isToday,
		isPastDue,
		nearestAppointment,
		isSurgery,
	};
}
